<template>
    


    <card class="card" title="Edita las columnas del sistema">
      <template slot="header">
        <h4 class="card-title">Claves de columna <!--<router-link class="pull-right" :to="{path:'/columnas/crear'}"><i class="ti ti-plus"></i></router-link>--></h4>
      </template>



      <div>
        <p>Nombra las columnas de tu archivo excel de acuerdo a la columna clave</p>
      <!--  <router-link class="btn btn-primary" :to="{path:'/columnas/crear'}">Agregar columna</router-link>-->
      

        <table class="table">

          <thead>
            <th>ID</th>
            <th>Nombre</th>
            <th>Clave</th>
            <th>Habilitado</th>
            <th>Acciones</th>

          </thead>

          <tbody>

            <tr v-for="(item,index) in data" :key="index">
              
              <td>
                {{ item.id }}

              </td>
              <td>
                {{ item.nombre }}

              </td>
              <td>
                {{ item.clave }}

              </td>
              <td>
                {{ item.activo=='1'?'Si':'No' }}

              </td>
              <td class="actions">

                  <router-link :to="{path:'/columnas/editar/'+item.id}"><i class="ti-pencil"></i></router-link>
                  <!--<a @click="deleteMe(item.id)" href="javascript:void(0)"><i class="ti-trash"></i></a>-->

              </td>
            
            </tr>


          </tbody>

        </table>

    </div>
    </card>


</template>


<script>



import api from '@/util/api';

export default{

    name:"Columnas",
    components:{
    },
    data(){

        return{

          data:[]
    
    
        }
      },

      methods:{


        getItems(){
            api.get('/columnas/').then(response=>{
              this.data=response.data.items;
              

            });
        },
        deleteMe(id){

          if(confirm('¿Desea eliminar el registro?')){
            api.delete('/columnas/'+id).then(()=>{

              this.getItems();
            }).catch(error=>{

              console.log(error);

            });
          }

        }


      },

      mounted(){


          this.getItems();

      }

    

}

</script>